const _excluded = ["children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';
import { jsx as ___EmotionJSX } from "@emotion/react";
function ToastTransition(_ref) {
  let {
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  console.log('ToastTransition', {
    props
  });
  return ___EmotionJSX(CSSTransition, _extends({
    classNames: "toast",
    timeout: 200
  }, props), children);
}
ToastTransition.defaultProps = {
  children: null
};
ToastTransition.propTypes = {
  children: PropTypes.node,
  done: PropTypes.func,
  isIn: PropTypes.bool,
  position: PropTypes.string,
  preventExitTransition: PropTypes.bool,
  enter: PropTypes.string,
  exit: PropTypes.string,
  append: PropTypes.bool,
  collapse: PropTypes.bool,
  collapseDuration: PropTypes.number
};
export default ToastTransition;